import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import '../css/ManageNotificationsUsers.css';
import api from '../utils/axiosConfig';

const ManageNotificationsUsers = () => {
  const [notifications, setNotifications] = useState([]);
  const [filteredNotifications, setFilteredNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [currentUser, setCurrentUser] = useState(null);
  const [selectedParticipant, setSelectedParticipant] = useState('all');
  const navigate = useNavigate();
  const [sortOption, setSortOption] = useState('');
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem('authToken');
      
      if (!token) {
        setError('Nicht authentifiziert.');
        setLoading(false);
        return;
      }

      try {
        const decoded = jwtDecode(token);
        const userResponse = await api.get(`/api/users/${decoded._id}`);
        setCurrentUser(userResponse.data);

        const notificationsResponse = await api.get(`/api/notifications`);

        const codePrefix = userResponse.data.code.slice(0, 5);
        const filtered = notificationsResponse.data.notifications.filter(
          notification => notification.userCode.startsWith(codePrefix)
        );
        
        setNotifications(notificationsResponse.data.notifications);
        setFilteredNotifications(filtered);
        setLoading(false);
      } catch (err) {
        setError(err.response?.data?.error || 'Failed to fetch data');
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (selectedParticipant !== 'all') {
      const filtered = notifications.filter(
        n => n.userCode.startsWith(currentUser?.code.slice(0, 5)) && 
             n.userCode === selectedParticipant
      );
      setFilteredNotifications(filtered);
    } else {
      const filtered = notifications.filter(
        n => n.userCode.startsWith(currentUser?.code.slice(0, 5))
      );
      setFilteredNotifications(filtered);
    }
  }, [selectedParticipant, notifications, currentUser]);

  //useEffect to filter the the sheduler entries
  /* useEffect(() => {
    
    let sorted = [...filteredNotifications];

    if (sortOption === 'date-asc') {
      sorted.sort((a, b) => new Date(a.scheduledAt) - new Date(b.scheduledAt));
    }

    if (sortOption === 'date-desc') {
      sorted.sort((a, b) => new Date(b.scheduledAt) - new Date(a.scheduledAt));
    }

    if (sortOption === 'status-sent') {
      sorted.sort((a, b) => (b.sent === true) - (a.sent === true));
    }

    if (sortOption === 'status-pending') {
      sorted.sort((a, b) => (a.sent === true) - (b.sent === true));
    }

    setFilteredNotifications(sorted);
  
  }, [sortOption]); */

  const handleDelete = async (notificationId) => {
    if (!window.confirm('Sind Sie sicher, dass Sie diese Benachrichtigung löschen möchten?')) return;
    
    try {
      await api.delete(`/api/notifications/${notificationId}`);
      
      setNotifications(notifications.filter(n => n._id !== notificationId));
      setFilteredNotifications(filteredNotifications.filter(n => n._id !== notificationId));
    } catch (err) {
      setError(err.message);
    }
  };

  const uniqueParticipants = Array.from(
    new Set(notifications.map(n => n.userCode))
  ).filter(code => code.startsWith(currentUser?.code.slice(0, 5) || ''));

  /* if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">{error}</div>; */


  if (loading) return (
    <div className="loading-container">
      <div className="spinner"></div>
      <p>Lade Zeitplan...</p>
    </div>
  );
  
  if (error) return (
    <div className="error-container">
      <div className="error-icon">!</div>
      <p>{error}</p>
    </div>
  );

  let sortedNotifications = [...filteredNotifications];

  if (sortOption === 'date-asc') {
    sortedNotifications.sort(
      (a, b) => new Date(a.scheduledAt) - new Date(b.scheduledAt)
    );
  }

  if (sortOption === 'date-desc') {
    sortedNotifications.sort(
      (a, b) => new Date(b.scheduledAt) - new Date(a.scheduledAt)
    );
  }

  if (sortOption === 'status-sent') {
    sortedNotifications.sort(
      (a, b) => (b.sent === true) - (a.sent === true)
    );
  }

  if (sortOption === 'status-pending') {
    sortedNotifications.sort(
      (a, b) => (a.sent === true) - (b.sent === true)
    );
  }

  const displayedNotifications = showAll
    ? sortedNotifications
    : sortedNotifications.slice(0, 5);

  return (
    <div className="notification-list-container">
      <div className="notification-header">
        <h1>Zeitplan</h1>
        <div className="header-controls">
          {filteredNotifications.length > 5 && (
            <button
              type="button"
              className="show-all-button"
              onClick={() => setShowAll(!showAll)}
            >
              {showAll ? 'Weniger anzeigen' : 'Alle anzeigen'}
            </button>
          )}
          {/* <select
            value={selectedParticipant}
            onChange={(e) => setSelectedParticipant(e.target.value)}
            className="participant-filter"
          > */}
          <select
            value={selectedParticipant}
            onChange={(e) => {
              setSelectedParticipant(e.target.value);
              setShowAll(false);
            }}
            className="participant-filter"
          >
            <option value="all">Alle Teilnehmer</option>
            {uniqueParticipants.map(code => (
              <option key={code} value={code}>{code}</option>
            ))}
          </select>
          {/* <select
            value={sortOption}
            onChange={(e) => setSortOption(e.target.value)}
            className="sort-dropdown"
          > */}
            <select
              value={sortOption}
              onChange={(e) => {
                setSortOption(e.target.value);
                setShowAll(false);
              }}
              className="sort-dropdown"
            >
            <option value="">Sortieren nach</option>
            <option value="date-asc">Datum ↑</option>
            <option value="date-desc">Datum ↓</option>
            <option value="status-sent">Status: Gesendet zuerst</option>
            <option value="status-pending">Status: Ausstehend zuerst</option>
          </select>

          <Link 
            to="/my-notifications/new" 
            className="create-button"
            state={{ 
              linkedParticipants: uniqueParticipants.map(code => ({
                code,
                _id: notifications.find(n => n.userCode === code)?._id
              }))  
            }}
          >
            Neuen Zeitplan erstellen
          </Link>
        </div>
      </div>
      <div className="notifications-table-wrapper">
      <table className="notifications-table">
        <thead>
          <tr>
            <th>Teilnehmer Code</th>
            <th>Datum & Uhrzeit</th>
            <th>Status</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {displayedNotifications.map(notification => (
            <tr key={notification._id}>
              <td>{notification.userCode}</td>
              <td>
                {new Date(notification.scheduledAt).toLocaleString('de-DE', {
                  timeZone: 'Europe/Berlin',
                  hour12: false,
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </td>
              <td>{notification.sent ? 'Gesendet' : 'Ausstehend'}</td>
              <td className="actions">
                <button 
                  onClick={() => navigate(`/my-notifications/${notification._id}/edit`)}
                  className="edit-button"
                  disabled={notification.sent}
                >
                  Bearbeiten
                </button>
                <button 
                  onClick={() => handleDelete(notification._id)}
                  className="delete-button"
                >
                  Löschen
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default ManageNotificationsUsers;